export default function Numpy_ArrayIndexing() {
  return <div>Numpy_ArrayIndexing Component</div>;
}
